import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import kzCommon from './locales/kz/common.json';
import ruCommon from './locales/ru/common.json';

export const SUPPORTED_LANGUAGES = ['ru', 'kz'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { common: ruCommon },
      kz: { common: kzCommon },
    },
    fallbackLng: 'ru',
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

/**
 * `<html lang>` следует за языком интерфейса: по нему браузер выбирает
 * локализованные формы глифов шрифта (казахская кириллица) и правила
 * переносов. Код языка данных `kz` → BCP-47 `kk`.
 */
const HTML_LANG: Record<string, string> = { ru: 'ru', kz: 'kk' };

const syncDocumentLang = (lng: string) => {
  document.documentElement.lang = HTML_LANG[lng] ?? lng;
};

syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
